import { Component, Input } from '@angular/core'
import { sweetAlert } from '../../../bmAlert'
import { Request } from '../../../graphql/queries/keyword.queries'
import { CustomerActions } from '../../../actions/customer-actions'
import { RequestMutations } from 'src/graphql/mutations/request.mutations'
import { updateCustomersNavRequestsCount } from '../utils'

@Component({
  selector: 'video-item',
  template: `
    <div class="row">
      <div class="col-8 d-flex flex-row flex-child-truncate justify-content-start align-items-center">
        <i class="visible-xs mr-2 fas state-icon "
          [ngClass]="{
            'fa-pause': request.state === 'draft',
            'fa-times': request.state === 'deleted',
            'fa-check': ['fulfilled', 'active'].includes(request.state)
          }"
        ></i>
        <div class="text-truncate cursor-pointer" [routerLink]="['request', request.id, 'edit']">{{request.videoTitle}}</div>
        <div class="hover-actions">
          <a class="ml-2 text-gray no-decoration item-action-button" [routerLink]="['request', request.id, 'edit']">
            <span *ngIf="!draftOrDeleted(request)">View</span>
            <span *ngIf="draftOrDeleted(request)">View/Edit</span>
          </a>
          <a class="ml-2 text-gray no-decoration item-action-button" [routerLink]="['new', 99]" [queryParams]="{'dupId': request.id}">
            Duplicate
          </a>
          <a *ngIf="canDeleteRequest()"
            (click)="deleteRequest({customerId: customerId, id: request.id})"
            class="ml-2 text-gray no-decoration item-action-button cursor-pointer">
            Delete
          </a>
        </div>
      </div>
      <div class="col-4 d-flex text-nowrap flex-row justify-content-end align-items-center">
        <span class="badge badge-tertiary badge-pill ml-2">{{request.type === 'VideoRequest' ? 'Video' : request.type}}</span>
      </div>
    </div>
  `
})
export class VideoItem {
  @Input() public customerId: number
  @Input() public request: Request
  @Input() adminImpersonating = false

  constructor(
    private customerActions: CustomerActions,
    private requestMutations: RequestMutations,
  ) {}

  draftOrDeleted(request: Request): boolean {
    return ['draft', 'deleted'].includes(request['state'])
  }

  deleteRequest({ customerId, id }: { customerId: number, id: number }): void {
    sweetAlert.confirm({title: 'Delete Request?', text: 'Are you sure?'}).then(confirm => {
      if (confirm) {
        this.requestMutations.deleteRequest({ customerId, id }).then(data => {

          // Can be removed after using Graphql for left nav customers
          if (data) updateCustomersNavRequestsCount(data, this.customerActions)
        })
      }
    })
  }

  canDeleteRequest(): boolean {
    return this.request.state === 'draft' || this.adminImpersonating
  }
}
